import { createSlice } from '@reduxjs/toolkit';

export const SCREEN_MODE_MONITORING = 'monitoring';
export const SCREEN_MODE_EDIT = 'edit';
export const SCREEN_MODE_PREVIEW = 'preview';

const initialState = {
    mode: null,
    fullScreen: false,
};

const { actions, reducer } = createSlice({
    name: 'screenInfo',
    initialState,
    reducers: {
        setMode: (state, action) => {
            state.mode = action.payload;
        },
        setFullScreen: (state, action) => {
            state.fullScreen = action.payload;
        },
    },
});

export const { setMode, setFullScreen } = actions;
export default reducer;
